import { getClientLocaleFromClientCookie } from '@/src/lib/dictionary/utils';
import { createWithLocalePlugin } from '@/src/lib/http/plugins/with-locale';

export function createWithLocaleHeaderPluginClient() {
  return createWithLocalePlugin(getClientLocaleFromClientCookie);
}
